import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CopyBoxComponent } from '@lite-workspace/shared/blocks/copy-box';

/**
 * One share link: caption row (label + projected `[hint]` «?» + projected `[actions]` icon buttons)
 * over the one-click copy box. `value` null = the link is still loading: an h-11 skeleton holds the
 * box's footprint so the dialog opens at its final height. An empty string = no link: the caption
 * stays, the box is left out.
 */
@Component({
  selector: 'hlm-share-link-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CopyBoxComponent],
  host: { class: 'flex flex-col gap-1.25' },
  template: `
    <span class="flex items-center gap-1 px-0.5 text-xs leading-4 text-c3">
      {{ label() }}
      <ng-content select="[hint]" />
      <ng-content select="[actions]" />
    </span>
    @if (value() === null) {
      <div class="h-11 animate-pulse rounded-[var(--r-l)] border border-line2 bg-bg2 motion-reduce:animate-none"></div>
    } @else if (value(); as link) {
      <app-copy-box [value]="link" [copyLabel]="copyLabel()" [copiedLabel]="copiedLabel()" (copied)="copied.emit()" />
    }
  `,
})
export class HlmShareLinkField {
  readonly label = input.required<string>();
  readonly value = input<string | null>(null);
  /** Accessible name of the copy box; the value is appended by the box itself. */
  readonly copyLabel = input('Скопировать ссылку');
  readonly copiedLabel = input('Ссылка скопирована');
  readonly copied = output<void>();
}
